import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {computed} from "vue";
import {ref, watch} from "vue";

interface Props {
  indeterminate?: boolean
  modelValue?: number,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SogProgressBar',
  props: {
    indeterminate: { type: Boolean, default: false },
    modelValue: { default: undefined }
  },
  setup(__props: any) {


const _props = __props

const _indeterminate = computed(() => {
  return _props.indeterminate ?? false
})

watch((_props), () => {
  _value.value = _props.modelValue
})

const _value = ref<number | undefined>(undefined)


return (_ctx: any,_cache: any) => {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!

  return (_openBlock(), _createBlock(_component_v_progress_linear, {
    modelValue: _value.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_value).value = $event)),
    indeterminate: _indeterminate.value,
    color: "#22d3ee"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["modelValue", "indeterminate"]))
}
}

})